import { useField } from '@unform/core';
import React, {
  InputHTMLAttributes,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { Icon } from '../Icon';
import { colors } from '../../styles/tokens';
import { Container, ContainerError, ContainerInput, Input } from './styles';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  style?: any;
}

// Código de convite/verificação sempre tem 5 caracteres -- ver
// `CodeGenerateProvider` no backend.
const CODE_LENGTH = 5;

const InputToken: React.FC<inputProps> = ({ name, style, ...rest }) => {
  const inputElementRef = useRef<HTMLInputElement>(null);

  const [isFocused, setIsFocused] = useState(false);

  const { defaultValue, fieldName, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputElementRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  return (
    <Container style={style}>
      <ContainerInput isErrored={!!error} isFocused={isFocused}>
        <Input
          ref={inputElementRef}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          defaultValue={defaultValue}
          maxLength={CODE_LENGTH}
          autoComplete="off"
          {...rest}
        />
      </ContainerInput>

      {!!error && (
        <ContainerError>
          <Icon name="error" size={16} color={colors.error} />
          <span>{error}</span>
        </ContainerError>
      )}
    </Container>
  );
};

export { InputToken };
